import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * DashboardSection — small uppercase eyebrow title + optional right slot.
 * `collapsible` sections render (and therefore fetch) their content only once opened.
 */
export function DashboardSection({ title, right, subtitle, icon: Icon, children, testId, collapsible = false, defaultOpen = true, onOpen }) {
  const [open, setOpen] = useState(!collapsible || defaultOpen);
  const toggle = () => { const next = !open; setOpen(next); if (next && onOpen) onOpen(); };
  const Heading = collapsible ? 'button' : 'div';
  return (
    <section className="space-y-3" data-testid={testId}>
      {(title || right) && (
        <div className="flex items-end justify-between gap-3 flex-wrap pt-1">
          <Heading
            {...(collapsible ? { type: 'button', onClick: toggle, 'aria-expanded': open, 'data-testid': `${testId}-toggle` } : {})}
            className={`flex items-center gap-2 ${collapsible ? 'rounded-md px-2 py-1 -mx-2 hover:bg-muted/60 transition-colors' : ''}`}
          >
            {Icon && <Icon size={14} className="text-muted-foreground" />}
            <h2 className="text-[11px] font-bold uppercase tracking-[0.14em] text-muted-foreground">{title}</h2>
            {subtitle && <span className="text-[11px] text-muted-foreground/70">· {subtitle}</span>}
            {collapsible && (
              <ChevronDown size={14} className={`text-muted-foreground transition-transform ${open ? 'rotate-180' : ''}`} />
            )}
          </Heading>
          {right && <div className="flex items-center gap-2">{right}</div>}
        </div>
      )}
      {open ? children : null}
    </section>
  );
}

export default DashboardSection;
